export default __webpack_public_path__ + "static/media/faq-category-icon-3.17da63a5.svg";